<template>
    <div>
        <h2>{{ $t("settings.smart-routing.Business hours") }}</h2>
        <p>{{ $t("settings.smart-routing.business-hours-description") }}</p>

        <b-form-group
            id="fieldset-enabled"
            :description="$t('settings.smart-routing.business-hours-enable-label')"
            :label="$t('settings.smart-routing.Business hours')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="name"
        >
            <b-form-checkbox
                v-model="getSettingByName(`enabled`, '0').value"
                inline
                name="enabled"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <div v-if="getSettingByName(`enabled`).value == 1">
            <validation-provider #default="{ errors }" name="timezone" rules="required">
                <b-form-group
                    id="fieldset-timezone"
                    :label="$t('locale.timezone')"
                    :state="errors.length > 0 ? false : null"
                    content-cols-lg="7"
                    content-cols-sm
                    label-cols-lg="3"
                    label-cols-sm="4"
                    label-for="timezone"
                >
                    <v-select
                        id="timezone"
                        v-model="getSettingByName('timezone', 'Europe/Amsterdam').value"
                        :options="timezones"
                        :state="errors.length > 0 ? false : null"
                        variant="primary"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>

            <b-form-group
                v-for="day in days"
                :id="`fieldset-businessHours_active_${day}`"
                :key="`fieldset-businessHours_active_${day}`"
                :label="$t(`locale.days.${day}`)"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="timezone"
            >
                <b-container>
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-checkbox
                                v-model="getSettingByName(`businessHours_active_${day.toLowerCase()}`, '0').value"
                                :name="`businessHours_active_${day}`"
                                inline
                                switch
                                unchecked-value="0"
                                value="1"
                            />
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-timepicker
                                v-model="getSettingByName(`businessHours_start_${day.toLowerCase()}`).value"
                                :locale="this && this.$i18n.locale"
                                :name="`businessHours_start_${day.toLowerCase()}`"
                            />
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-timepicker
                                v-model="getSettingByName(`businessHours_end_${day.toLowerCase()}`).value"
                                :locale="this && this.$i18n.locale"
                                :name="`businessHours_end_${day.toLowerCase()}`"
                            />
                        </b-col>
                    </b-row>
                </b-container>
            </b-form-group>
        </div>
        <hr />
    </div>
</template>

<script>
import {
    BContainer,
    BCol,
    BRow,
    BCard,
    BFormGroup,
    BFormCheckbox,
    BFormTimepicker,
    BInputGroup,
    BButton,
} from "bootstrap-vue";
import useRoutes from "../useRoutes";
import moment from "moment-timezone";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BContainer,
        BCol,
        BRow,
        BFormGroup,
        BFormCheckbox,
        BCard,
        ValidationProvider,
        ValidationObserver,
        BFormTimepicker,
        vSelect,
        BInputGroup,
        BButton,
    },
    data() {
        return {
            required,
            timezones: moment.tz.names(),
            days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        };
    },
    setup(props) {
        const toast = useToast();
        const { getSettingByName } = useRoutes();
        return {
            getSettingByName,
            toast,
        };
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
